import { DefaultButton, TooltipHost, Spinner, SpinnerSize } from '@fluentui/react';
import { useContext, useMemo, useRef } from 'react';
import { ColumnWrapper } from '../../instalationPointsList.styles';
import { CustomTextArea, stylesForButton, stylesForToolTip, StyledIcon } from './vivotekUpdateConfiguration.styles';
import { useTranslation } from 'react-i18next';
import { InstallationPointsContext } from '../../../../../../installationPoints';
import getNewDataPushServer from '../../../../../../../../utils/vivotekHelpers/getNewDataPushServer';

/**
 * Компонент для отрисовки колонки для обновления конфигурации датчика для VIVOTEK
 * @param {object} selectedSensor объект выбранного сенсора
 * @param {object} iPoint объект точки установки
 * @param {string} accessKey ключ для выгрузки
 * @param {object} availableBundlesByIPointId объект связок, где ключ это id связки
 */
const VivotekUpdateConfiguration = ({ uploadKey, selectedSensor, availableBundlesByIPointId, iPoint }) => {
    const { updateSensorConfigurationThunkTrans, sensorUploadUrlsBySensorType } = useContext(InstallationPointsContext);

    const { t } = useTranslation();
    const copyRef = useRef();

    const uploadUrl = sensorUploadUrlsBySensorType[selectedSensor.sensor_type]?.uploadUrl;
    const CORRECT_URL = `${uploadUrl?.protocol}://${uploadUrl?.host}/fpc/v1/${selectedSensor.sensor_type}/${uploadKey}`;

    const bundleData = useMemo(() => {
        if (availableBundlesByIPointId?.[iPoint?.id]) {
            return availableBundlesByIPointId[iPoint.id];
        }
        return null;
    }, [availableBundlesByIPointId, iPoint]);

    const copyHandler = () => {
        copyRef.current.value = CORRECT_URL;
        copyRef.current.focus();
        copyRef.current.select();
        try {
            document.execCommand('copy');
        } catch (error) {
            console.log(error);
        }
    };

    const updateHandler = () => {
        const dataPushServer = getNewDataPushServer({ accessKey: uploadKey, uploadUrl });
        updateSensorConfigurationThunkTrans({
            sensorType: selectedSensor.sensor_type,
            sensorId: selectedSensor.id,
            availableBundlesByIPointId,
            data: dataPushServer,
            iPointId: iPoint.id,
        });
    };

    if (!uploadKey) {
        return (
            <ColumnWrapper>
                <>{t('No access key')}</>
            </ColumnWrapper>
        );
    }

    if (bundleData?.updateConfigurationFetching) {
        return (
            <ColumnWrapper>
                <Spinner size={SpinnerSize.large} />
            </ColumnWrapper>
        );
    }
    if (bundleData?.isFetched && bundleData?.thirdStepError && !bundleData?.firstStepError) {
        return (
            <ColumnWrapper>
                <CustomTextArea ref={copyRef} />
                <DefaultButton styles={stylesForButton} onClick={updateHandler}>
                    {t('Update')}
                </DefaultButton>
                <TooltipHost content={CORRECT_URL} styles={stylesForToolTip}>
                    <StyledIcon onClick={copyHandler} iconName="Copy" />
                </TooltipHost>
            </ColumnWrapper>
        );
    }
    return (
        <ColumnWrapper>
            <CustomTextArea ref={copyRef} />
            <TooltipHost content={CORRECT_URL}>
                <DefaultButton styles={stylesForButton} onClick={copyHandler}>
                    {t('Copy link')}
                </DefaultButton>
            </TooltipHost>
        </ColumnWrapper>
    );
};

export default VivotekUpdateConfiguration;
